// extracted by mini-css-extract-plugin
export default {"main__button":"styles_main__button__RzWbo","secondary__button":"styles_secondary__button__ZvkLX"};